import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlahPipe } from '@headpower/blah-ng';

import { AuthCallbackComponent } from './callback/callback.component';

@NgModule({
    declarations: [
        AuthCallbackComponent
    ],
    imports: [
        CommonModule,
        BlahPipe
    ],
    exports: [
        AuthCallbackComponent
    ],
    providers: [
    ]
})
export class AuthModule { }
